export default __webpack_public_path__ + "static/media/mail.48a63251.svg";